import { render } from "./BankAccountUpdatePhoto.vue?vue&type=template&id=2900b78c&scoped=true"
import script from "./BankAccountUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./BankAccountUpdatePhoto.vue?vue&type=script&lang=js"

import "./BankAccountUpdatePhoto.vue?vue&type=style&index=0&id=2900b78c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2900b78c"]])

export default __exports__